'use strict';

const helper = require('../../helper');

const AlertHandler = require('../alertHandler/venmoAlertHandlerModel');
const VenmoBase = require('./venmoBase');

/**
 * Venmo Express Checkout model
 */
class VenmoExpressCheckout extends VenmoBase {
    #formData;

    constructor(pageFlow){
        super(pageFlow);

        this.alertHandler = new AlertHandler();
    }

    async init() {
        const braintreeClientInstance = await this.venmoModelInstance.btVenmoModel.braintreeClientInstancePromise;
        const isEnrichedCustomerDataEnabled
            = braintreeClientInstance.getConfiguration().gatewayConfiguration.payWithVenmo.enrichedCustomerDataEnabled;

        if (isEnrichedCustomerDataEnabled) {
            await this.initButton();
        }
    }

    #createFormData(payload) {
        const payerInfo = payload.details.payerInfo;

        if (!payerInfo.billingAddress || !payerInfo.shippingAddress) {
            throw new Error(this.configs.messages.VENMO_NO_BILLING_SHIPPING);
        }

        const venmoHelper = require('../helpers/venmoHelper');

        const venmoButtonEl = document.querySelector('.js-venmo-express-checkout');
        const csrfTokenEl = venmoButtonEl.querySelector('#csrf_token');
        const deviceDataEl = document.getElementById('braintree-venmo-device-data');

        const checkoutFormFields = venmoButtonEl.getAttribute('data-checkout-form-fields');
        const billingAddress = venmoHelper.createBillingAddress(payerInfo);
        const shippingAddress = venmoHelper.createShippingAddress(payerInfo);
        const checkoutFormData = {
            ...billingAddress,
            country: billingAddress.countryCode,
            email: payerInfo.email,
            paymentMethod: 'Venmo'
        };

        this.#formData = helper.createPaymentFormData(checkoutFormFields, checkoutFormData);

        this.#formData.append(csrfTokenEl.name, csrfTokenEl.value);
        this.#formData.append('braintreeVenmoNonce', payload.nonce);
        this.#formData.append('braintreeVenmoRiskData', deviceDataEl.value);
        this.#formData.append('braintreeVenmoShipping', JSON.stringify(shippingAddress) || '{}');
        this.#formData.append('braintreeVenmoBilling', JSON.stringify(billingAddress) || '{}');
        this.#formData.append('braintreeVenmoUserId', payload.details.username);
        this.#formData.append('expressCheckoutFlow', true);
    }

    async processPayment(payload) {
        const paymentMethodGeneral = require('../../paymentMethodGeneral');

        try {
            // submit customer form with email (CheckoutServices-SubmitCustomer)
            // as we skip step "login via guest/registered user" while express checkout
            // email is set only in case of guest checkout and if email is not already set
            paymentMethodGeneral.submitCustomerForm(payload.details.payerInfo.email);
            this.#createFormData(payload);

            const response = await fetch(helper.getUrlWithCsrfToken(window.braintreeUrls.checkoutSubmitPayment), {
                method: 'POST',
                body: this.#formData
            });

            const data = await response.json();

            if (!helper.handleSubmitPaymentErrors(data, this.alertHandler)) {
                sessionStorage.setItem('pageState', this.configs.pageFlow);
                window.location.href = window.braintreeUrls.placeOrderUrl;
            }
        } catch (error) {
            if (!error.response) {
                this.alertHandler.showError(error.message || error);
            } else {
                const errorDetails = await error.response.json();

                this.alertHandler.showError(errorDetails.statusMessage);
            }

            this.loader.hide();
        }
    }
}

module.exports = VenmoExpressCheckout;
